var React = require('react');

function Running (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.66667 3.33333C9.03486 3.33333 9.33333 3.03486 9.33333 2.66667C9.33333 2.29848 9.03486 2 8.66667 2C8.29848 2 8 2.29848 8 2.66667C8 3.03486 8.29848 3.33333 8.66667 3.33333Z","stroke":"#666666","strokeWidth":"1.33","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2.66602 11.333L5.99935 11.9997L6.49935 10.9997M9.99935 13.9997V11.333L7.33268 9.33301L7.99935 5.33301","stroke":"#666666","strokeWidth":"1.33","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M4.66602 7.99967V5.99967L7.99935 5.33301L9.99935 7.33301L11.9993 7.99967","stroke":"#666666","strokeWidth":"1.33","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Running.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Running;

Running.default = Running;
